import numerologyChange from './actions/numerologyChange';
import numerologyCreate from './actions/numerologyCreate';
import numerologyDetail from './actions/numerologyDetail';
import numerologyList from './actions/numerologyList';
import getNumerologyItems from './getters/getNumerologyItems';
import numerologyListUpload from './mutations/numerologyListUpload';

const actions = {
    numerologyChange,
    numerologyCreate,
    numerologyDetail,
    numerologyList
};

const mutations = {
    numerologyListUpload
};

const getters = {
    getNumerologyItems
};

export default { actions, mutations, getters };
